<template>
  <div class="editor" style="background: black;border-radius:10px;">
    <!-- <editor-content :editor="editor" style="background: #161616;color:white;border:3px solid whitesmoke;padding: 20px;" /> -->
    <editor-content :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import { 
  CodeBlockHighlight,
  HardBreak,
  Heading,
  Bold,
  Code,
  Italic,
} from 'tiptap-extensions'

// import Doc from './tiptap-doc-singleline.js'
// import { Paragraph, Text } from 'tiptap'

import javascript from 'highlight.js/lib/languages/javascript'
import css from 'highlight.js/lib/languages/css'
import swift from 'highlight.js/lib/languages/swift'

import apache from 'highlight.js/lib/languages/apache'
// import applescript from 'highlight.js/lib/languages/applescript'
// import arduino from 'highlight.js/lib/languages/arduino' // This one has problems...
// import awk from 'highlight.js/lib/languages/awk'
// import bash from 'highlight.js/lib/languages/bash'
// import basic from 'highlight.js/lib/languages/basic'
import brainfuck from 'highlight.js/lib/languages/brainfuck'
import clojure from 'highlight.js/lib/languages/clojure'
// import cpp from 'highlight.js/lib/languages/cpp'
// import dart from 'highlight.js/lib/languages/dart'
// import django from 'highlight.js/lib/languages/django'
// import dockerfile from 'highlight.js/lib/languages/dockerfile'
import elixir from 'highlight.js/lib/languages/elixir'
import erlang from 'highlight.js/lib/languages/erlang'
import excel from 'highlight.js/lib/languages/excel'
// import fortran from 'highlight.js/lib/languages/fortran'
// import go from 'highlight.js/lib/languages/go'
import gradle from 'highlight.js/lib/languages/gradle'
import groovy from 'highlight.js/lib/languages/groovy'
import haskell from 'highlight.js/lib/languages/haskell'
import java from 'highlight.js/lib/languages/java'
// import julia from 'highlight.js/lib/languages/julia'
import kotlin from 'highlight.js/lib/languages/kotlin'
import less from 'highlight.js/lib/languages/less'
// import llvm from 'highlight.js/lib/languages/llvm'
// import lua from 'highlight.js/lib/languages/lua'
// import makefile from 'highlight.js/lib/languages/makefile'
// import markdown from 'highlight.js/lib/languages/markdown'
// import mathematica from 'highlight.js/lib/languages/mathematica'
import matlab from 'highlight.js/lib/languages/matlab'
// import nginx from 'highlight.js/lib/languages/nginx'
// import objectivec from 'highlight.js/lib/languages/objectivec'
import perl from 'highlight.js/lib/languages/perl'
import php from 'highlight.js/lib/languages/php'
// plaintext
// powershell
// processing
// prolog 
// protobuf 
import puppet from 'highlight.js/lib/languages/puppet'
import python from 'highlight.js/lib/languages/python'
// r 
import r from 'highlight.js/lib/languages/r'
// ruby 
// rust 
import rust from 'highlight.js/lib/languages/rust'
// sas 
import sas from 'highlight.js/lib/languages/sas'
// scala 
// scheme 
// scilab 
import scss from 'highlight.js/lib/languages/scss'
// smalltalk 
// typescript 
// vbnet 
import verilog from 'highlight.js/lib/languages/verilog'
import vhdl from 'highlight.js/lib/languages/vhdl'
// vim 



export default {
  components: {
    EditorContent,
    Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: -1
    }
  },
  computed: {
    text() {
      if (this.editor.getJSON().content[0].content === undefined) {
        return ""
      } else {
        return this.editor.getJSON().content[0].content[0].text
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) { 
        if (!this.initialValueSet) {
          // this.editor.setContent(newVal)
          this.editor.setContent("<pre><code>" + newVal + "</code></pre>")
        }
        this.initialValueSet = true
      }, 
    },
    text: {
      immediate: false, 
      handler(newVal, oldVal) { 
        if (newVal === undefined) {
          newVal = ''
        }
        this.$emit('input', newVal)
      }, 
    }
  },
  data() {
    return {
      initialValueSet: false,
      focus: false,
      editor: new Editor({
        // useBuiltInExtensions: false,
        extensions: [
          // new Doc(), // custom extension
          // new Text(), // default extension
          // new Paragraph(), // default extension
          // new Heading({ levels: [2] }),
          new CodeBlockHighlight({
            languages: {
              javascript,
              css,
              swift,
              apache,
              // applescript,
              // arduino,
              // awk,
              // bash,
              // basic,
              brainfuck,
              // clojure,
              // cpp,
              // dart,
              // django,
              // dockerfile,
              elixir,
              erlang,
              excel,
              // fortran,
              // go,
              gradle,
              groovy,
              haskell,
              java,
              // julia,
              kotlin,
              less,
              // llvm,
              // lua,
              // makefile,
              // markdown,
              // mathematica,
              matlab,
              // nginx,
              // objectivec,
              perl,
              php,
              puppet,
              python,
              r,
              rust,
              sas,
              scss,
              verilog,
              vhdl
            },
          }),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new Bold(),
          new Code(),
          new Italic()
        ],
        content: ` 
        `,
        onFocus: () => {
          this.focus = true
          if (this.index >= 0) {
            this.$emit('item-focus', this.index)
          }
        },
        onBlur: () => {
          this.focus = false
          if (this.index >= 0) {
            this.$emit('item-blur', this.index)
          }
        },
      })
    }
  },
  methods: {
    del() {
      console.log("del")
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
*:focus {
    outline: none;
}

span {
  color: white;
}

pre code {
  // override the inherit
  color: white !important
}

pre {
  &::before {
    content: attr(data-language);
    text-transform: uppercase;
    display: block;
    text-align: right;
    font-weight: bold;
    font-size: 0.6rem;
  }
  code {
    .hljs-comment,
    .hljs-quote {
      color: #999999;
    }
    .hljs-variable,
    .hljs-template-variable,
    .hljs-attribute,
    .hljs-tag,
    .hljs-name,
    .hljs-regexp,
    .hljs-link,
    .hljs-name,
    .hljs-selector-id,
    .hljs-selector-class {
      color: #f2777a;
    }
    .hljs-number,
    .hljs-meta,
    .hljs-built_in,
    .hljs-builtin-name,
    .hljs-literal,
    .hljs-type,
    .hljs-params {
      color: #f99157;
    }
    .hljs-string,
    .hljs-symbol,
    .hljs-bullet {
      color: #99cc99;
    }
    .hljs-title,
    .hljs-section {
      color: #ffcc66;
    }
    .hljs-keyword,
    .hljs-selector-tag {
      color: #6699cc;
    }
    .hljs-emphasis {
      font-style: italic;
    }
    .hljs-strong {
      font-weight: 700;
    }
  }
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Source+Code+Pro&display=swap');

.editor {
  /* font-family: 'Source Code Pro', monospace; */
  padding: 20px;
}

pre::before > code {
  color: yellow
}

button {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:30px;
    height:30px;
    border-radius: 3px;
    margin: 2px;
    /* border:1px solid gray; */
}

.is-active {
  background: lightgray
}
</style>